export default __webpack_public_path__ + "static/media/sho6.3f8c8692.jpg";